<template>
    <div>
        <div>
        <slot>
            <ui-button  
                id="expenseSelector"
                ref="trigger"
                :disabled="disabled"
                icon="attach_money" 
                style="width: 100%; margin-bottom: .5rem; justify-content: left;"
            >Part / Expense</ui-button>
        </slot>
        </div>
        <ui-popover ref="popover" trigger="#expenseSelector" v-show="!disabled" @open="onOpen" class="expense-selector">
            <div style="padding: 0; width: 500px;">
                <ui-tabs @tab-change="resetSelected" style="margin-bottom: 0;">
                    <ui-tab v-if="canAllocateParts" title="Parts">
                    <div v-show="isLoadingParts" class="text-center"><cog-loader></cog-loader></div>
                        <div v-show="!isLoadingParts" style="padding-bottom: .25rem">
                            <div style="max-height: 308px; overflow-y: auto; ">
                                <div>
                                    <ui-textbox
                                        v-model="search"
                                        icon="search"
                                        placeholder="Search"
                                    ></ui-textbox>
                                </div>
                                <table class="table table-auto">
                                    <tbody v-if="filteredParts.length > 0">
                                        <tr v-for="item in filteredParts">
                                            <td>
                                                <ui-checkbox v-model="item.selected"></ui-checkbox>
                                            </td>
                                            <td>
                                                <div>{{ item.description }}</div>
                                                <div style="color: #999">{{ item.number }}</div>
                                            </td>
                                            <td class="text-center" style="width: 130px;">
                                                <ui-icon-button
                                                    style="vertical-align: middle;"
                                                    icon="remove"
                                                    size="small"
                                                    @click="decrement(item)"
                                                ></ui-icon-button>
                                                <ui-textbox
                                                    v-model="item.quantity_selected"
                                                    class="qty-text-box"
                                                ></ui-textbox>
                                                <ui-icon-button
                                                    style="vertical-align: middle;"
                                                    icon="add"
                                                    size="small"
                                                    @click="increment(item)"
                                                ></ui-icon-button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="3">No parts items available</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </ui-tab>
                    <ui-tab title="Expenses">
                        <div v-show="isLoadingExpenses" class="text-center"><cog-loader></cog-loader></div>
                        <div v-show="!isLoadingExpenses" style="padding-bottom: .25rem">
                            <div style="max-height: 308px; overflow-y: auto; ">
                                <div>
                                    <ui-textbox
                                        v-model="search"
                                        icon="search"
                                        placeholder="Search"
                                    ></ui-textbox>
                                </div>
                                <table class="table table-auto">
                                    <tbody v-if="filteredExpenseItems.length > 0">
                                        <tr v-for="item in filteredExpenseItems">
                                            <td>
                                                <ui-checkbox v-model="item.selected"></ui-checkbox>
                                            </td>
                                            <td>
                                                <div>{{ item.description }}</div>
                                                <div style="color: #999">{{ item.expense.contact.primary_display_as }}</div>
                                            </td>
                                            <td class="text-center" style="width: 130px;">
                                                <ui-icon-button
                                                    style="vertical-align: middle;"
                                                    icon="remove"
                                                    size="small"
                                                    @click="decrement(item)"
                                                ></ui-icon-button>
                                                <ui-textbox
                                                    v-model="item.quantity_selected"
                                                    class="qty-text-box"
                                                ></ui-textbox>
                                                <ui-icon-button
                                                    style="vertical-align: middle;"
                                                    icon="add"
                                                    size="small"
                                                    @click="increment(item)"
                                                ></ui-icon-button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="3">No expense items available</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </ui-tab>
                </ui-tabs>

                    <div style="padding: 0.5rem 1rem;">
                            <div class="row mb-2 mt-2">
                                <div class="col-8">
                                    <ui-button
                                        :disabled="0 === selectedParts.length && 0 === selectedExpenses.length"
                                        @click="attach"
                                        color="primary"
                                    >Attach</ui-button>
                                    <ui-button
                                        :disabled="0 === selectedExpenses.length"
                                        @click="remove"
                                        type="secondary"
                                        color="red"
                                    >Write Off</ui-button>
                                </div>
                                <div class="col text-right">
                                    <ui-button
                                        id="addButton"
                                        color="green"
                                        icon="add"
                                    >
                                        New
                                    </ui-button>
                                    <ui-popover
                                        ref="addPop"
                                        trigger="#addButton"
                                        position="bottom-end"
                                    >
                                        <div
                                            class="dropdown-menu show"
                                            style="position: relative;"
                                        >
                                            <a
                                                href="#"
                                                class="dropdown-item"
                                                @click.prevent="addExpense(); $refs.addPop.close();"
                                            >
                                                New Expense
                                            </a>
                                            <a
                                                href="#"
                                                class="dropdown-item"
                                                @click.prevent="addCredit(); $refs.addPop.close();"
                                            >
                                                New Credit
                                            </a>
                                            <a
                                                href="#"
                                                class="dropdown-item"
                                                @click.prevent="addCost(); $refs.addPop.close();"
                                            >
                                                Add Estimate
                                            </a>
                                        </div>
                                    </ui-popover>
                                </div>
                            </div>
                    </div>
            </div>
        </ui-popover>

        <expense-modal 
            ref="expenseModal"
            :team="this.task.team"
            :instance="this.task.instance"
            :disable-team-selection-on-valid-team="false"
            @saved="expenseSaved"
        />

        <internal-cost-modal
            ref="internalCost"
            :task="task"
            @saved="costSaved"
        />
    </div>
</template>

<style lang="scss">
    .expense-selector {
        .qty-text-box {
            width: 30px; 
            display: inline-block; 
            margin-bottom: 0;

            input { text-align: center; }
        }

        .table tr:first-of-type {
            td { border-top: none; }
        }
    }
</style>

<script>
    import ExpenseModal from '../ExpenseModal'
    import InternalCostModal from './EstimateModal'
    import { TaskResource } from '../../../classes/Api/Task'
    import fuzzysearch from "fuzzysearch";
    import {ExpenseResource} from "../../../classes/Api/Expense";
    import DealerKit from "../../../api";
    import {loadPartsList} from "../../../../ts/Parts/PartsListLoader";

    export default {
        components: {
            ExpenseModal,
            InternalCostModal,
        },
        props: {
            task: {},
            disabled: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            id: {
                default() {
                    return Math.random();
                }
            }
        },
        mounted() {
            if (this.expense) {
                this.selected = this.expense;
            }
        },
        watch: {
            expense: {
                handler: function(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.selected = (newVal === null ? {} : newVal);
                    }
                },
                deep: true,
            },
        },
        data() {
            return {
                search: '',
                parts: [],
                availableExpenseItems: [],
                isLoadingExpenses: true,
                isLoadingParts: true,
                itemsLoaded: false,
            }
        },
        computed: {
            canAllocateParts() {
                return this.$store.getters['user/can']('allocate.inventory')
            },
            selectedExpenses() {
                return this.availableExpenseItems.filter(item => {
                    return true === item.selected
                })
            },
            selectedParts() {
                return this.parts.filter(item => {
                    return true === item.selected
                })
            },
            filteredExpenseItems() {
                return this.availableExpenseItems.filter(item => {
                    if (this.search.length === 0) {
                        return true
                    }

                    return fuzzysearch(
                        this.search.toLowerCase(),
                        (item.description + ' ' + item.expense.contact.primary_display_as).toLowerCase()
                    )
                })
            },
            filteredParts() {
                return this.parts.filter(part => {
                    return this.search.length === 0 ||
                        part.description.toLowerCase().indexOf(this.search.toLowerCase()) !== -1 ||
                        part.number.toLowerCase().indexOf(this.search.toLowerCase()) !== -1
                })
            }
        },
        methods: {
            resetSelected() {
                this.parts.forEach(part => {
                    part.selected = false
                    part.quantity_selected = 1
                })

                this.availableExpenseItems.forEach(item => {
                    item.selected = false
                    item.quantity_selected = item.quantity_remaining
                })
            },
            invalidateLoadedItems() {
              this.itemsLoaded = false
            },
            addExpense() {
                this.$refs.expenseModal.open()
                this.reset();
            },
            addCredit() {
                this.$refs.expenseModal.open({ is_credit: true })
                this.reset();
            },
            expenseSaved(expense) {
                let items = _.cloneDeep(expense.items);
                let selectedIds = items.map(i => i.id)
                this.itemsLoaded = false
                this.onOpen(selectedIds).then(r => {
                    // Determine the likelyhood of the expense having items
                    // that are meant for different jobs, not just the current one.
                    // If the likelyhood is high, we show the item selector, otherwise
                    // we just attach the items to improve UX.
                    let highQuantity = items.filter(i => i.quantity >= 2).length > 0

                    if (highQuantity || items.length >= 2) {
                        this.show()
                    } else {
                        this.attach()
                    }
                })
            },
            addCost() {
                this.$refs.internalCost.open()
                this.reset();
            },
            costSaved(item) {
                this.$emit('attached', item)
            },
            attach() {
                this.reset();
                for (let i in this.selectedExpenses) {
                    this.$emit('attach-expense', this.selectedExpenses[i])
                }

                for (let i in this.selectedParts) {
                    this.$emit('attach-part', this.selectedParts[i])
                }
            },
            remove() {
                if (confirm('Are you sure you want to permanently write-off these items?')) {
                    this.isLoadingExpenses = true
                    const promises = []
                    for (let i in this.selected) {
                        const item = this.selected[i]
                        promises.push(
                            ExpenseResource.writeOffItem(item.expense_id, item.id, item.quantity_selected)
                        );
                    }

                    Promise.all(promises).finally(() => {
                        this.itemsLoaded = false
                        this.onOpen()
                    })
                }
            },
            increment(item) {
                if (item.quantity_selected < item.quantity_remaining) {
                    item.quantity_selected++
                }
            },
            decrement(item) {
                if (item.quantity_selected > 1) {
                    item.quantity_selected--
                }
            },
            save() {
                this.$emit('save', Object.assign({}, this.selected));
            },
            destroy() {
                this.$emit('save', null, null);
            },
            reset() {
                this.itemsLoaded = false
                this.$refs['popover'].close();
            },
            show() {
                this.search = ''
                this.$refs.popover.open()
            },
            onOpen(selectedIds = []) {
                this.isLoadingExpenses = true;

                return new Promise((resolve, reject) => {
                    if (!this.itemsLoaded) {
                        TaskResource.attachableExpenseItems(this.task.id).then(response => {
                            this.availableExpenseItems = response.data.map(item => {
                                item.quantity_selected = item.quantity_remaining;
                                item.selected = selectedIds.indexOf(item.id) > -1
                                return item
                            });
                            this.isLoadingExpenses = false

                            return loadPartsList()
                        }).then(inventory => {
                            this.parts = JSON.parse(JSON.stringify(inventory.map(part => {
                                part.selected = false
                                part.quantity_selected = 1
                                part.quantity_remaining = 9999999
                                return part
                            })))

                            this.isLoadingParts = false
                            this.itemsLoaded = true

                            resolve();
                        }).catch(e => {
                            handleApiError(e);
                            reject();
                            this.isLoadingExpenses = false;
                            this.isLoadingParts = false
                        });
                    } else {
                        this.isLoadingExpenses = false
                        this.isLoadingParts = false
                        resolve();
                    }
                })
            }
        }
    }
</script>